import _ from 'lodash';
import { actions } from '../actions';

const initialState = [];

export const currentTeamsReducer = (state = initialState, action) => {
  switch (action.type) {
    case actions.GET_TEAMS_SUCCEED:
      return action.payload;
    case actions.GET_TEAMS_FAILURE:
      return [];
    case actions.CREATE_TEAM_SUCCEED:
      return [
        ...state.filter(({ id }) => id !== _.get(action, 'payload.id')),
        action.payload
      ];
    case actions.UPDATE_TEAM_SUCCEED:
      return [
        ...state.map(team => {
          return team.id === _.get(action, 'payload.id')
            ? { ...team, ...action.payload }
            : team;
        })
      ];
    case actions.DELETE_TEAM_SUCCEED:
      return [...state.filter(({ id }) => id !== _.get(action, 'payload.id'))];
    case actions.CREATE_TEAM_FAILURE:
    case actions.UPDATE_TEAM_FAILURE:
      return state;
    default:
      return state;
  }
};
